import { memo, ReactNode } from 'react';
import { ModalWrapper } from '../ModalWrapper';
import { MobileModalWrapper } from '../MobileModalWrapper';
import { useWindowSize } from 'react-easyrocket';

interface ResponsiveModalWrapperProps {
  children?: ReactNode;
  childrenMobile?: ReactNode;
  onClose?: () => void;
  className?: string;
  classNameMobile?: string;
  containerClassName?: string;
  containerClassNameMobile?: string;
  isTransparentBg?: boolean;
  isTransparentBgMobile?: boolean;
  showCross?: boolean;
}

export const ResponsiveModalWrapper = memo(function ResponsiveModalWrapper({
  children,
  childrenMobile,
  onClose,
  className,
  classNameMobile,
  containerClassName,
  containerClassNameMobile,
  isTransparentBg,
  isTransparentBgMobile,
  showCross
}: ResponsiveModalWrapperProps) {
  const { is640 } = useWindowSize();

  if (is640) {
    return (
      <ModalWrapper
        onClose={onClose}
        className={className}
        containerClassName={containerClassName}
        isTransparentBg={isTransparentBg}
        showCross={showCross}>
        {children}
      </ModalWrapper>
    );
  }
  return (
    <MobileModalWrapper
      onClose={onClose}
      className={classNameMobile ?? className}
      containerClassName={containerClassNameMobile ?? containerClassName}
      isTransparentBg={isTransparentBgMobile ?? isTransparentBg}
      showCross={showCross}>
      {childrenMobile ?? children}
    </MobileModalWrapper>
  );
});
